import selectableListItemBehavior from './selectableListItemBehavior';
import basicListItemBehavior from './basicListItemBehavior';
/**
 * @description
 * Defines a behavior "BasicListItemBehavior" or "SelectableListItemBehavior" based on "selectable" property.
 */
var listItemBehavior = function (props) {
    return props.selectable ? selectableListItemBehavior(props) : basicListItemBehavior(props);
};
export default listItemBehavior;
